export default __webpack_public_path__ + "static/media/about_background.a36eda2b.png";